/*
  custom.js — all One Nation JavaScript additions live here.
  Loaded with `defer` from snippets/custom-head.liquid, so the DOM is ready
  when this runs. Never edit Taiga's own JS files; hook in from here instead.
*/
(function () {
  'use strict';

  // Icon constants stay ABOVE all init calls — the card annotator runs at
  // load time and reads them immediately.
  var ICON_PACKAGE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="m7.5 4.27 9 5.15"/>' +
    '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>' +
    '<path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>';

  var ICON_INFO =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  // True for nodes our own code inserts or rewrites (class prefix
  // custom-b2b-). MutationObservers below skip these so they don't react
  // to their own output.
  function isOwnNode(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !!(el && el.closest && el.closest('[class*="custom-b2b-"]'));
  }

  function moneyFormatter(currency) {
    return function (cents) {
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: currency || 'AUD',
        }).format(cents / 100);
      } catch (err) {
        return '$' + (cents / 100).toFixed(2);
      }
    };
  }

  /*
    B2B collection/listing cards: annotate each product card with a
    "Wholesale" caption and the RRP. Card prices are contextual (catalog)
    for B2B sessions, so retail prices come from anonymous requests:
    one bulk /collections/<handle>/products.json on collection pages,
    /products/<handle>.js per product elsewhere, cached in sessionStorage.
  */
  function initB2bCardRrp(cfg) {
    var CACHE_KEY = 'custom-b2b-rrp-v1';
    var format = moneyFormatter(cfg.currency);

    var cache = {};
    try {
      cache = JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {};
    } catch (err) {
      cache = {};
    }

    function saveCache() {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      } catch (err) {
        /* storage unavailable — annotations still work this pageview */
      }
    }

    function centsFromVariants(variants) {
      var prices = variants
        .map(function (v) {
          // /products/<h>.js uses integer cents; products.json uses "9.95"
          return typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
        })
        .filter(function (n) {
          return !isNaN(n);
        });
      if (!prices.length) return null;
      return { min: Math.min.apply(null, prices), varies: Math.min.apply(null, prices) !== Math.max.apply(null, prices) };
    }

    function collectCards() {
      return [].slice.call(document.querySelectorAll('.card--product .card-body')).map(function (body) {
        var link = body.querySelector('.card-title a');
        var match = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!match || body.querySelector('.custom-b2b-card-rrp')) return null;
        return { body: body, handle: match[1] };
      }).filter(Boolean);
    }

    function annotate() {
      collectCards().forEach(function (card) {
        var price = card.body.querySelector('.price');
        if (!price) return;

        // Wrap price (+ RRP) in one flex row so CSS can bottom-align it
        // within the card regardless of title length.
        var row = card.body.querySelector('.custom-b2b-price-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'custom-b2b-price-row';
          price.parentNode.insertBefore(row, price);
          row.appendChild(price);
        }

        if (!price.querySelector('.custom-b2b-card-icon')) {
          var icon = document.createElement('span');
          icon.className = 'custom-b2b-card-icon';
          icon.innerHTML = ICON_PACKAGE;
          price.insertBefore(icon, price.firstChild);
        }

        var retail = cache[card.handle];
        if (!retail) return;

        var rrp = document.createElement('span');
        rrp.className = 'custom-b2b-card-rrp';
        rrp.textContent =
          cfg.strings.rrp_label +
          (retail.varies ? ' ' + cfg.strings.from_label : '') +
          ' ' +
          format(retail.min);
        row.appendChild(rrp);
      });
    }

    function fetchMissing() {
      var missing = [];
      collectCards().forEach(function (card) {
        if (!cache[card.handle] && missing.indexOf(card.handle) === -1) missing.push(card.handle);
      });
      if (!missing.length) {
        annotate();
        return;
      }

      var collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)\/?$/);
      var bulk = collectionMatch
        ? fetch('/collections/' + collectionMatch[1] + '/products.json?limit=250', { credentials: 'omit' })
            .then(function (res) {
              return res.ok ? res.json() : null;
            })
            .then(function (json) {
              if (!json || !json.products) return;
              json.products.forEach(function (p) {
                var entry = centsFromVariants(p.variants || []);
                if (entry) cache[p.handle] = entry;
              });
            })
            .catch(function () {})
        : Promise.resolve();

      bulk
        .then(function () {
          var still = missing.filter(function (h) {
            return !cache[h];
          }).slice(0, 24);
          return Promise.all(
            still.map(function (handle) {
              return fetch('/products/' + handle + '.js', { credentials: 'omit' })
                .then(function (res) {
                  return res.ok ? res.json() : null;
                })
                .then(function (p) {
                  if (!p || !p.variants) return;
                  var entry = centsFromVariants(p.variants);
                  if (entry) cache[handle] = entry;
                })
                .catch(function () {});
            })
          );
        })
        .then(function () {
          saveCache();
          annotate();
        });
    }

    fetchMissing();

    // Collection filtering/pagination re-renders the grid via AJAX;
    // annotate() is idempotent, so a debounced observer is safe.
    var timer;
    new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return !isOwnNode(m.target); })) return;
      clearTimeout(timer);
      timer = setTimeout(fetchMissing, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  var b2bConfig = readJson('custom-b2b-config');
  if (b2bConfig) initB2bCardRrp(b2bConfig);

  /*
    Judge.me floating REVIEWS tab: square off the two corners that touch
    the window edge. The tab's orientation varies (horizontal on very wide
    screens, rotated elsewhere), so detect rotation + edge at runtime and
    zero the pre-rotation corners that map to the window side.
    Judge.me inserts the button before its stylesheet lands, so for a
    moment it has no size and no rotation; measuring then picked the wrong
    corners until the next resize. apply() skips an unsized button and a
    ResizeObserver re-runs it once the button is laid out.
  */
  function initJdgmTabCorners() {
    var tries = 0;
    var timer = setInterval(function () {
      var btn = document.querySelector('.jdgm-revs-tab-btn');
      if (!btn) {
        if (++tries > 40) clearInterval(timer);
        return;
      }
      clearInterval(timer);

      var R = '200px';
      function apply() {
        var rect = btn.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var touchRight = rect.right > window.innerWidth - 24;
        var touchLeft = rect.left < 24;
        if (!touchRight && !touchLeft) return;

        var angle = 0;
        try {
          var m = new DOMMatrix(getComputedStyle(btn).transform);
          angle = Math.round((Math.atan2(m.b, m.a) * 180) / Math.PI);
        } catch (err) {
          angle = 0;
        }

        var radius; // border-radius order: TL TR BR BL (pre-rotation)
        if (angle === 90) {
          radius = touchRight ? '0 0 ' + R + ' ' + R : R + ' ' + R + ' 0 0';
        } else if (angle === -90) {
          radius = touchRight ? R + ' ' + R + ' 0 0' : '0 0 ' + R + ' ' + R;
        } else {
          radius = touchRight ? R + ' 0 0 ' + R : '0 ' + R + ' ' + R + ' 0';
        }
        btn.style.setProperty('border-radius', radius, 'important');
      }

      apply();
      window.addEventListener('resize', apply);
      window.addEventListener('load', apply);
      if ('ResizeObserver' in window) new ResizeObserver(apply).observe(btn);
    }, 250);
  }
  initJdgmTabCorners();

  /*
    B2B product page (Shopify Plus native B2B).
    custom-head.liquid emits #custom-b2b-product-data on product pages for
    logged-in company contacts. We:
    - apply the active variant's catalog rules (min / increment / max) to the
      quantity input so Taiga's +/- buttons (stepUp/stepDown) respect them;
    - show the rule as a "Wholesale" pill above the buy row;
    - add a "log out for RRP" note beneath the buy row;
    - show the RRP beside the wholesale price. Every Liquid price object is
      contextual (catalog) in a B2B session, so the retail price is fetched
      from the public /products/<handle>.js endpoint WITHOUT session cookies
      (credentials: 'omit') — an anonymous request returns retail pricing.

    Taiga's .add-to-cart-container is a 2-column grid (quantity | button),
    so the pill and note are inserted OUTSIDE it — anything injected inside
    becomes a grid item and wrecks the button layout.
  */
  function initB2bProductPage() {
    var dataEl = document.getElementById('custom-b2b-product-data');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var retailPrices = null;
    if (data.handle) {
      fetch('/products/' + data.handle + '.js', { credentials: 'omit' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (retail) {
          if (!retail || !retail.variants) return;
          retailPrices = {};
          retail.variants.forEach(function (v) {
            retailPrices[v.id] = v.price;
          });
          apply();
        })
        .catch(function () {});
    }

    function getBuyRow() {
      return form.querySelector('.add-to-cart-container') || form;
    }

    function getQuantityInput() {
      return (
        (form.id && document.querySelector('input[name="quantity"][form="' + form.id + '"]')) ||
        form.querySelector('input[name="quantity"]')
      );
    }

    function getVariantId() {
      var idInput = form.querySelector('[name="id"]');
      return idInput ? idInput.value : null;
    }

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: data.currency || 'AUD',
        }).format(cents / 100);
      } catch (err) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function pillText(rule) {
      var parts = [data.strings.min.replace('[min]', rule.min)];
      if (rule.increment > 1) {
        parts.push(data.strings.increment.replace('[increment]', rule.increment));
      }
      if (rule.max) {
        parts.push(data.strings.max.replace('[max]', rule.max));
      }
      return parts.join(' · ');
    }

    function ensurePill(rule) {
      var buyRow = getBuyRow();
      var pill = document.querySelector('.custom-b2b-pill');
      if (!rule || (rule.min <= 1 && rule.increment <= 1 && !rule.max)) {
        if (pill) pill.remove();
        return;
      }
      if (!pill) {
        pill = document.createElement('div');
        pill.className = 'custom-b2b-pill';
        pill.innerHTML =
          ICON_PACKAGE +
          '<strong>' + data.strings.pill_label + '</strong>' +
          '<span class="custom-b2b-pill__rule"></span>';
        buyRow.parentNode.insertBefore(pill, buyRow);
      }
      pill.querySelector('.custom-b2b-pill__rule').textContent = pillText(rule);
    }

    function ensureLogoutNote() {
      if (document.querySelector('.custom-b2b-logout-note')) return;
      var buyRow = getBuyRow();
      var note = document.createElement('p');
      note.className = 'custom-b2b-logout-note';
      note.innerHTML = ICON_INFO + '<span></span>';
      note.querySelector('span').textContent = data.strings.logout_note;
      buyRow.parentNode.insertBefore(note, buyRow.nextSibling);
    }

    function ensureRrp() {
      if (!retailPrices) return;
      var priceWrap = document.querySelector('div[id^="price-"]');
      var variantId = getVariantId();
      if (!priceWrap || !variantId) return;

      var cents = retailPrices[variantId];
      var row = priceWrap.querySelector('.custom-b2b-rrp-row');
      if (cents == null) {
        if (row) row.remove();
        return;
      }
      if (!row) {
        row = document.createElement('div');
        row.className = 'custom-b2b-rrp-row';
        row.innerHTML = '<span class="custom-b2b-rrp"></span>';
        priceWrap.appendChild(row);
      }
      row.querySelector('.custom-b2b-rrp').textContent =
        data.strings.rrp_label + ' ' + formatMoney(cents);

      // Sit Taiga's "Tax included." line to the right of the badge.
      var tax = priceWrap.querySelector('.product__tax');
      if (tax && tax.parentNode !== row) row.appendChild(tax);
    }

    function apply() {
      var rule = data.variants[getVariantId()] || null;
      var input = getQuantityInput();

      if (rule && input) {
        input.min = rule.min;
        input.step = rule.increment;
        if (rule.max) input.max = rule.max;

        var value = parseInt(input.value, 10) || 0;
        if (value < rule.min) {
          input.value = rule.min;
        } else if ((value - rule.min) % rule.increment !== 0) {
          input.value = rule.min + Math.ceil((value - rule.min) / rule.increment) * rule.increment;
        }
      }

      ensurePill(rule);
      ensureLogoutNote();
      ensureRrp();
    }

    apply();

    // Re-apply after variant changes; Taiga's variant pickers bubble change
    // events, and its price block re-render can wipe the RRP badge.
    // Debounced so we run once after its own handlers settle.
    var timer;
    document.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    });
  }

  initB2bProductPage();

  /*
    B2B cart (drawer + /cart page): carry the catalog quantity rules into
    the cart line items. custom-head.liquid renders
    snippets/custom-b2b-cart-rules.liquid (#custom-b2b-cart-rules) with
    one entry per cart line, in line order. We:
    - set min/step/max on each line's quantity input so Taiga's +/- buttons
      (stepUp/stepDown) respect the rule;
    - correct typed values in the capture phase, BEFORE Taiga's cart-items
      change handler reads them, so off-increment quantities never reach
      /cart/change (which would otherwise reject them with a red error);
    - render a compact "Wholesale" rule pill under each line's title.
    Taiga swaps #cart-items' innerHTML on every cart update, wiping our
    attributes and pills, so a MutationObserver re-applies them, and the
    rules are re-fetched via sections/custom-b2b-cart-rules.liquid after
    cart:update / ajaxProduct:added because lines may be added or
    renumbered. A typed 0 is left alone so the line can still be removed.
  */
  function initB2bCart() {
    var data = readJson('custom-b2b-cart-rules');
    if (!data || !data.lines) return;

    function hasRule(rule) {
      return rule && (rule.min > 1 || rule.increment > 1 || !!rule.max);
    }

    function ruleForInput(input) {
      var index = parseInt(input.dataset.index, 10);
      if (!index) return null;
      return data.lines[index - 1] || null;
    }

    function pillText(rule) {
      var parts = [data.strings.min.replace('[min]', rule.min)];
      if (rule.increment > 1) {
        parts.push(data.strings.increment.replace('[increment]', rule.increment));
      }
      if (rule.max) {
        parts.push(data.strings.max.replace('[max]', rule.max));
      }
      return parts.join(' · ');
    }

    function normalise(value, rule) {
      if (value <= 0) return 0;
      if (value < rule.min) return rule.min;
      var step = rule.increment > 1 ? rule.increment : 1;
      var snapped = rule.min + Math.ceil((value - rule.min) / step) * step;
      if (rule.max && snapped > rule.max) {
        snapped = rule.min + Math.floor((rule.max - rule.min) / step) * step;
      }
      return snapped;
    }

    function applyToInput(input) {
      var rule = ruleForInput(input);
      var item = input.closest('.cart-item');
      var pill = item ? item.querySelector('.custom-b2b-pill--cart') : null;

      if (!hasRule(rule)) {
        if (pill) pill.remove();
        return;
      }

      input.min = rule.min;
      input.step = rule.increment > 1 ? rule.increment : 1;
      if (rule.max) input.max = rule.max;
      else input.removeAttribute('max');

      if (!item) return;
      var details = item.querySelector('.cart-item__details');
      if (!details) return;
      if (!pill) {
        pill = document.createElement('div');
        pill.className = 'custom-b2b-pill custom-b2b-pill--cart';
        pill.innerHTML =
          ICON_PACKAGE +
          '<strong>' + data.strings.pill_label + '</strong>' +
          '<span class="custom-b2b-pill__rule"></span>';
        details.appendChild(pill);
      }
      var ruleEl = pill.querySelector('.custom-b2b-pill__rule');
      var text = pillText(rule);
      if (ruleEl.textContent !== text) ruleEl.textContent = text;
    }

    function applyAll() {
      var inputs = document.querySelectorAll('cart-items input[name="updates[]"]');
      Array.prototype.forEach.call(inputs, applyToInput);
    }

    var fetching = null;
    function refreshRules() {
      if (fetching) return fetching;
      fetching = fetch('/cart?section_id=custom-b2b-cart-rules', {
        credentials: 'same-origin',
      })
        .then(function (res) {
          return res.ok ? res.text() : null;
        })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.getElementById('custom-b2b-cart-rules');
          if (!el) return;
          var fresh = JSON.parse(el.textContent);
          if (fresh && fresh.lines) data = fresh;
          applyAll();
        })
        .catch(function () {})
        .then(function () {
          fetching = null;
        });
      return fetching;
    }

    // Snap typed values before Taiga's bubbling change handler posts them.
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!input.matches || !input.matches('cart-items input[name="updates[]"]')) return;
        var rule = ruleForInput(input);
        if (!hasRule(rule)) return;
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = rule.min;
        var fixed = normalise(value, rule);
        if (fixed !== value) input.value = fixed;
      },
      true
    );

    // Re-apply after Taiga re-renders the line items (innerHTML swap).
    var timer;
    function scheduleApply() {
      clearTimeout(timer);
      timer = setTimeout(applyAll, 50);
    }
    // Ignore the mutations we make ourselves (pill insert / text update);
    // reacting to them would loop and keep every other observer's
    // debounce on the page from ever settling.
    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return !isOwnNode(m.target); })) scheduleApply();
    });
    function observe() {
      Array.prototype.forEach.call(document.querySelectorAll('cart-items'), function (el) {
        observer.observe(el, { childList: true, subtree: true });
      });
    }
    observe();

    // Lines can be added or renumbered: refresh the rule list.
    document.addEventListener('cart:update', function () {
      refreshRules();
    });
    document.addEventListener('ajaxProduct:added', function () {
      // Taiga fetches the drawer contents on this event; wait for it.
      setTimeout(refreshRules, 400);
    });

    applyAll();
  }

  initB2bCart();

  /*
    Breaking news hero (sections/custom-hero-breaking.liquid): scroll the
    ticker strip as a seamless marquee. The track is duplicated once so the
    loop has no gap, driven by requestAnimationFrame at data-speed px/s.
    Pauses on hover/focus and stays static under prefers-reduced-motion.
    Re-runs on shopify:section:load so it works in the theme editor.
  */
  function initBreakingHeroTicker(root) {
    var scope = root || document;
    var tickers = scope.querySelectorAll('[data-breaking-ticker]');
    if (!tickers.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(tickers, function (ticker) {
      if (ticker.dataset.tickerReady) return;
      ticker.dataset.tickerReady = '1';
      var track = ticker.querySelector('.custom-breaking-hero__ticker-track');
      if (!track || reduceMotion) return;

      var speed = parseFloat(ticker.dataset.speed) || 50;
      var originalHtml = track.innerHTML;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var loopWidth = track.scrollWidth + gap;
      var copies = 1;
      // Fill at least twice the visible width so the loop never shows a gap.
      while (loopWidth * copies < ticker.clientWidth * 2 && copies < 6) copies += 1;
      for (var i = 0; i < copies; i += 1) track.insertAdjacentHTML('beforeend', originalHtml);

      var offset = 0;
      var paused = false;
      var last = null;

      function step(now) {
        if (last === null) last = now;
        var dt = (now - last) / 1000;
        last = now;
        if (!paused && dt < 0.5) {
          offset -= speed * dt;
          if (-offset >= loopWidth) offset += loopWidth;
          track.style.transform = 'translate3d(' + offset.toFixed(2) + 'px,0,0)';
        }
        window.requestAnimationFrame(step);
      }

      ticker.addEventListener('mouseenter', function () { paused = true; });
      ticker.addEventListener('mouseleave', function () { paused = false; });
      ticker.addEventListener('focusin', function () { paused = true; });
      ticker.addEventListener('focusout', function () { paused = false; });
      window.addEventListener('resize', function () {
        loopWidth = (track.scrollWidth + gap) / (copies + 1);
      });

      window.requestAnimationFrame(step);
    });
  }
  initBreakingHeroTicker();
  document.addEventListener('shopify:section:load', function (event) {
    initBreakingHeroTicker(event.target);
  });

  /*
    Essential Free Shipping top ribbon: it is sticky at top 0 like Taiga's
    header, so measure its height into --custom-ship-bar-h and flag <html>
    with .custom-ship-ribbon; custom.css then sticks the header just
    below it. Re-measures on resize (the ribbon wraps to two lines on
    narrow screens) and when the app injects or removes the bar.

    The app injects the ribbon about a second after load, which pushed the
    whole page down. custom-head.liquid flags <html> with
    .custom-ship-ribbon-pending before first paint and custom.css draws an
    orange placeholder of the same height; the ResizeObserver below swaps
    the placeholder for the real ribbon in the frame it gets its height,
    so nothing moves. The last measured height is remembered in
    localStorage (0 = no ribbon, so nothing is reserved next time). If no
    ribbon has shown PENDING_MS after load the placeholder is dropped.
  */
  function initShippingRibbonOffset() {
    var root = document.documentElement;
    var STORAGE_KEY = 'custom-ship-bar-h';
    var PENDING_CLASS = 'custom-ship-ribbon-pending';
    var PENDING_MS = 4000;
    var observed = null;
    var ro = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    function remember(h) {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(h));
      } catch (err) { /* storage blocked: reserve the default next time */ }
    }
    function measure() {
      var bar = document.querySelector('.essential_free_shipping_bar_wrapper.top_page');
      if (ro && bar && bar !== observed) {
        if (observed) ro.unobserve(observed);
        observed = bar;
        ro.observe(bar);
      }
      var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      if (h > 0) {
        root.style.setProperty('--custom-ship-bar-h', h + 'px');
        root.classList.add('custom-ship-ribbon');
        root.classList.remove(PENDING_CLASS);
        remember(h);
      } else {
        // The placeholder still needs the reserved height while pending.
        if (!root.classList.contains(PENDING_CLASS)) {
          root.style.removeProperty('--custom-ship-bar-h');
        }
        root.classList.remove('custom-ship-ribbon');
      }
    }
    measure();
    window.addEventListener('resize', measure);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(measure);
      mo.observe(document.body, { childList: true, subtree: true });
      // Stop watching once the app has settled; resize covers the rest.
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
    setTimeout(function () {
      if (!root.classList.contains(PENDING_CLASS)) return;
      root.classList.remove(PENDING_CLASS);
      remember(0);
      measure();
    }, PENDING_MS);
  }
  initShippingRibbonOffset();

  /*
    Overlay header: shadow strength that fades with scroll. Taiga's
    overlay header (header.header.overlay) sits transparent over the
    homepage hero, and custom.css gives the logo, nav and icons a navy
    text/drop shadow. This writes --custom-hdr-shadow (1 at the top of
    the page, 0 once scrolled 200px) onto <html> so the CSS can scale the
    shadow alpha, rather than snapping it off with Taiga's
    sticky-header-show class (which only flips at 300px).
  */
  function initHeaderScrollShadow() {
    if (!document.querySelector('header.header.overlay')) return;
    var root = document.documentElement;
    var FADE_PX = 200;
    var ticking = false;
    function update() {
      var y = window.scrollY || root.scrollTop || 0;
      var strength = Math.max(0, Math.min(1, 1 - y / FADE_PX));
      root.style.setProperty('--custom-hdr-shadow', strength.toFixed(3));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }
  initHeaderScrollShadow();

  /*
    Search: products only. The blog articles are dated and Taiga's
    search page mixes them in with product cards. Shopify's search
    endpoint accepts type=product, so add that as a hidden field to every
    search form (drawer + search page). custom.css hides any article card
    that still gets through (e.g. a /search?q= link without the type
    parameter, or a facet re-render that drops it).
  */
  function initSearchProductsOnly() {
    var forms = document.querySelectorAll('form[action$="/search"][role="search"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.querySelector('input[name="type"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'type';
      input.value = 'product';
      form.appendChild(input);
    });
  }
  initSearchProductsOnly();
})();
